<h2 mat-dialog-title class="text-lg font-bold mb-1">Editar Distribución</h2>

<mat-dialog-content class="p-0 h-[700px]">
  <div class="inset-0 flex min-w-0 flex-col overflow-hidden">
    <mat-drawer-container class="bg-card h-full flex-auto dark:bg-transparent" (backdropClick)="onBackdropClicked()">

      <!-- Drawer derecho -->
      <mat-drawer #mainDrawer class="w-full dark:bg-gray-900 md:w-[80%]" [mode]="'side'" [opened]="drawerOpened"
        [position]="'end'" [disableClose]="true">
          <div class="flex flex-col sm:flex-row justify-between items-center mb-2 px-6 py-4 sticky top-0 z-10 bg-card">
            <h3 class="text-xl font-bold">
              <div class="flex items-center">
                <mat-icon class="mr-2" [ngClass]="selectedDocument()?.totalSpare > 0 ? 'text-amber-500' : 'text-blue-500'"
                  svgIcon="heroicons_outline:document-text"></mat-icon>
                {{ selectedDocument()?.noDto?.code }} - {{ selectedDocument()?.noDto?.serial }}
              </div>
              @if(expandedMaterial()){
              <div class="flex items-center text-sm">
                <mat-icon class="mr-2"
                  [ngClass]="(expandedMaterial()?.missing > 0 || expandedMaterial()?.spare > 0 ) ? 'text-red-500' : 'text-blue-500'"
                  svgIcon="heroicons_outline:cube"></mat-icon>
                {{expandedMaterial()?.material?.code}} - {{expandedMaterial()?.material?.name}}
              </div>
              }
            </h3>

            <button mat-stroked-button color="primary" (click)="closeDrawer()" matTooltip="Volver a Documentos">
              <div class="flex items-center">
                <div class="pr-1">
                  <mat-icon svgIcon="heroicons_outline:chevron-left"></mat-icon>
                </div>
                <div class="flex flex-col p-2 content-center text-center gap-[3px] min-w-[60px] w-20">
                  <span class="font-light">Documentos</span>
                </div>
              </div>
            </button>
          </div>

          <!-- Detalle de material -->
          <mat-drawer-container class="bg-card h-full flex-auto dark:bg-transparent">
            <!-- Drawer secundario: detalle del material -->
            <mat-drawer #childDrawer class="w-full dark:bg-gray-800 md:w-[75%]" [mode]="'side'" [position]="'end'"
              [opened]="childDrawerOpened">

              <app-distribution-material 
                [expandedMaterial]="expandedMaterial()"
                [UMPActive]="data.UMPActive"
                (closeDrawer)="closeDrawerChild($event)">
              </app-distribution-material>
            </mat-drawer>

            <!-- Detalle de documento -->
            <mat-drawer-content class="flex flex-col">
              <ng-container *ngIf="selectedDocument()">
                <div class="relative">
                  <ng-container *ngIf="deliveryGroupMaterialUnified().length > 0; else noMaterials">
                    <div *ngFor="let mat of deliveryGroupMaterialUnified()"
                      class="z-20 flex cursor-pointer items-center justify-between border-b px-6 py-4 hover:bg-gray-100"
                      [ngClass]="{ 'bg-primary-50': expandedMaterial()?.material?.code === mat.material?.code }"
                      (click)="openDocumentMaterial(mat)">
                      <div class="flex cursor-pointer items-center">
                        <mat-icon class="mr-2"
                          [ngClass]="(mat?.missing > 0 || mat?.spare > 0 ) ? 'text-red-500' : 'text-blue-500'"
                          svgIcon="heroicons_outline:cube"></mat-icon>
                        <div class="ml-2 leading-tight">
                          <div class="font-medium">{{ mat.material?.name }}</div>
                          <div class="text-secondary text-sm">{{ mat.material?.code }}</div>
                        </div>
                      </div>
                      @if(!childDrawerOpened){
                      <div class="flex gap-4">
                        <div class="bg-gray-50 rounded-lg p-2 text-center w-20">
                          <p class="text-xs text-gray-500">Faltante</p>
                          <p class="font-bold" [ngClass]="mat?.missing > 0 ? 'text-red-500' : 'text-gray-500'">
                            {{ mat?.missing ?? 0 | number: "1.3-3" }}</p>
                        </div>
                        <div class="bg-gray-50 rounded-lg p-2 text-center w-20">
                          <p class="text-xs text-gray-500">Sobrante</p>
                          <p class="font-bold" [ngClass]="mat?.spare > 0 ? 'text-red-500' : 'text-gray-500'">
                            {{ mat?.spare ?? 0 | number: "1.3-3" }}</p>
                        </div>
                        <div class="bg-gray-50 rounded-lg p-2 text-center w-20">
                          <p class="text-xs text-gray-500">UMB</p>
                          <p class="font-bold">{{ mat?.totalBaseQuantity | number: "1.3-3" }}</p>
                        </div>
                        <div class="bg-gray-50 rounded-lg p-2 text-center w-20">
                          <p class="text-xs text-gray-500">UMP</p>
                          <p class="font-bold">{{ mat?.totalPararellQuantity | number: "1.3-3" }}</p>
                        </div>
                      </div>
                      }
                    </div>
                  </ng-container>
                  <ng-template #noMaterials>
                    <div class="border-t p-8 text-center text-xl font-semibold">
                      No hay materiales disponibles
                    </div>
                  </ng-template>
                </div>
              </ng-container>
            </mat-drawer-content>
          </mat-drawer-container>
      </mat-drawer>

      <!-- Contenido principal: lista de documentos -->
      <mat-drawer-content class="flex flex-col">
        <div class="flex-auto">
          <!-- Header -->
          <div class="flex flex-col border-b px-6 py-4 sticky top-0 bg-card z-10">
            <h2 class="text-2xl font-bold">Documentos</h2>
            <p class="text-secondary leading-tight text-sm">{{ documentCount() }} documentos encontrados</p>
          </div>

          <!-- Lista de Documentos -->
          <div class="relative overflow-auto h-[500px]">
            <ng-container *ngIf="deliveryGroupUnified().length > 0; else noDocs">
              <div *ngFor="let doc of deliveryGroupUnified();trackBy: trackBySerial"
                class="z-20 flex cursor-pointer items-center justify-between border-b px-6 py-4 hover:bg-gray-100"
                [ngClass]="{ 'bg-primary-50': selectedDocument()?.noDto.serial === doc.noDto.serial }"
                (click)="openDocumentDetail(doc)">
                <div class="flex items-center">
                  <mat-icon class="mr-2" [ngClass]="doc.totalSpare > 0 ? 'text-amber-500' : 'text-blue-500'"
                    svgIcon="heroicons_outline:document-text"></mat-icon>
                  <div class="ml-2 leading-tight">
                    <div class="font-medium">{{ doc.noDto.serial }}</div>
                    <div class="text-secondary text-sm">{{ doc.noDto.code }}</div>
                  </div>
                </div>
                @if(!drawerOpened && doc.noDto.previousTransactions){
                  <div class="bg-gray-50 rounded-lg p-2 text-center w-50 leading-tight">
                    <p class="text-xs text-gray-500">Doc. Carga</p>
                    <p class="font-bold text-gray-500 text-sm leading-tight">
                      <ng-container *ngIf="getCode(doc?.noDto?.previousTransactions) as code">
                        <b class="f-10">{{ code }}</b>
                      </ng-container>
                      <span class="block">{{doc.noDto.previousTransactions.serial}}</span>
                    </p>
                  </div>
                }
              </div>
            </ng-container>

            <ng-template #noDocs>
              <div class="border-t p-8 text-center text-xl font-semibold">
                No hay documentos disponibles
              </div>
            </ng-template>
          </div>
        </div>
      </mat-drawer-content>
    </mat-drawer-container>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="modal-actions flex justify-between">
  <button mat-button mat-dialog-close>Cancelar</button>
  <span [matTooltip]="!isSaveDistribution() ? 'Falta distribución por asignar' : ''">
      <button mat-raised-button color="primary" [disabled]="!isSaveDistribution()"
      (click)="saveMaterialDistribution()">
        Guardar
      </button>
  </span>
</mat-dialog-actions>


<ng-template #updateDialog let-data>
  <div class="flex items-start space-x-2 m-4">
    <div class="flex items-center">
      <mat-icon class="text-amber-500 ml-4 mt-6" style="font-size: 32px">warning_amber</mat-icon>
    </div>
    <div class="grid">
      <h2 mat-dialog-title class="text-lg font-bold mb-1">
        {{ data.title }}
      </h2>
      <mat-dialog-content class="modal-content mt-0">
        <p>{{ data.description }}</p>
      </mat-dialog-content>
    </div>
  </div>
  <mat-dialog-actions class="modal-actions flex justify-end">
    <button mat-button mat-dialog-close class="align-left mr-3" [mat-dialog-close]="false">
      No
    </button>
    <button mat-raised-button color="primary" [mat-dialog-close]="true">
      Si
    </button>
  </mat-dialog-actions>
</ng-template>